import * as React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';
import * as styles from './NavLogo.module.scss';

export type NavLogoProps = {
    label: string;
    className?: string;
    classes?: Partial<typeof styles>;
    to: string;
    logo: React.ReactNode;
    fadeEffect?: boolean;
};

export default function NavLogo({
    label,
    to,
    className,
    classes,
    logo,
    fadeEffect = false,
}: NavLogoProps) {
    return (
        <Link
            to={to}
            rel="home"
            className={classnames(className, classes?.root, styles.root, {
                [styles.fadeEffect]: fadeEffect,
            })}
            aria-label={label}
        >
            {logo}
        </Link>
    );
}

NavLogo.defaultProps = {
    prefix: '',
};
